import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';

const Support: React.FC = () => {
  // Set page title to empty to hide header title and description
  usePageTitle('', '');
  
  return (
    <div className="text-center py-12">
      <p className="text-gray-600 dark:text-gray-400">
        For technical queries please contact your organization's master administrator for Governate.
      </p>
    </div>
  );
};

export default Support;
